/* A11Y: pause/play control for autoplaying hero videos + prefers-reduced-motion support. */
(function () {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const buttons = Array.from(document.querySelectorAll('[data-video-pause]'));

  function setPaused(btn, paused) {
    const wrapper = btn.closest('[data-video-pause-wrapper]') || btn.parentElement;
    wrapper.querySelectorAll('video').forEach((video) => {
      if (paused) {
        video.pause();
      } else {
        video.play().catch(function () {});
      }
    });
    btn.setAttribute('aria-pressed', String(paused));
    const label = btn.querySelector('[data-video-pause-label]');
    if (label) {
      label.textContent = paused ? btn.dataset.playLabel : btn.dataset.pauseLabel;
    }
  }

  buttons.forEach((btn) => {
    btn.addEventListener('click', function () {
      setPaused(btn, btn.getAttribute('aria-pressed') !== 'true');
    });
  });

  if (reduceMotion.matches) {
    document.querySelectorAll('video[autoplay]').forEach((video) => {
      video.pause();
      video.removeAttribute('autoplay');
    });
    buttons.forEach((btn) => btn.remove());
  }
})();
